import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import BodyStyleSection from '../BodyStyleSection';
import StatusIcon from '../../StatusIcon';

const SeriesNavElement = ({
  name,
  remainingQuota,
  totalQuota,
  submitted,
  bodyStyles,
  selectedModelId,
  nameStyle,
  seriesId,
}) => (
  <div className={styles.selectedSeriesElement}>
    <div className={styles.seriesHeader}>
      <div className={styles.name} style={nameStyle}>
        {name}
      </div>
      <StatusIcon totalQuota={totalQuota} submitted={submitted} />
    </div>
    <div className={styles.bodyStyles}>
      {bodyStyles.map(bodyStyleId => (
        <BodyStyleSection
          key={bodyStyleId}
          selectedModelId={selectedModelId}
          bodyStyleId={bodyStyleId}
          seriesId={seriesId}
        />
      ))}
    </div>
  </div>
);

export default enhance(SeriesNavElement);
